import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { commissionSlabQueries } from '@/services/slabs/slabs.queries';

export const useCommissionCategoryDetailList = (categoryDetailId: string | undefined) => {
  const { data, isLoading } = useQuery({
    ...commissionSlabQueries.detail(categoryDetailId || ''),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
    enabled: !!categoryDetailId,
  });

  return { commissionCategoryDetailList: data?.data ?? null, isLoading };
};
